export default {
    brick: {
        unlock: 'hordeBrickTower',
        sigils: ['bashing', 'toughness', 'strength', 'growing', 'fury'],
        statBase: 140,
        statScaling: 0.25,
        crowns: 1,
        heirlooms: ['brick'],
        reward: {
            50: {type: 'unlock', name: 'hordeUpgradeRoyalArmor', value: true},
            100: {type: 'mult', name: 'hordeHealth', value: 1.5},
            150: {type: 'mult', name: 'currencyHordeMonsterPartCap', value: 1.35},
            200: {type: 'base', name: 'hordeNostalgia', value: 50},
            300: {type: 'unlock', name: 'hordeUpgradeRoyalButcher', value: true},
            400: {type: 'base', name: 'hordeNostalgia', value: 50},
            500: {type: 'mult', name: 'currencyHordeBoneCap', value: 1.5},
        },
    },
    fire: {
        unlock: 'hordeFireTower',
        sigils: ['magicBolt', 'fireball', 'sparks', 'wisdom', 'berserk'],
        statBase: 170,
        statScaling: 0.3,
        crowns: 2,
        heirlooms: ['heat'],
        reward: {
            50: {type: 'unlock', name: 'hordeUpgradeRoyalStorage', value: true},
            100: {type: 'base', name: 'hordeMaxEquipment', value: 1},
            150: {type: 'mult', name: 'hordeAttack', value: 1.5},
            200: {type: 'base', name: 'currencyHordeMysticalShardCap', value: 10},
            300: {type: 'mult', name: 'currencyHordeBoneCap', value: 1.5},
            400: {type: 'mult', name: 'currencyHordeMonsterPartCap', value: 1.35},
        },
    },
    ice: {
        unlock: 'hordeIceTower',
        sigils: ['health', 'resistance', 'cold', 'angelic', 'iceGiant'],
        statBase: 200,
        statScaling: 0.35,
        crowns: 3,
        heirlooms: ['ice'],
        reward: {
            50: {type: 'mult', name: 'currencyHordeBoneGain', value: 1.5},
            100: {type: 'unlock', name: 'hordeUpgradeRoyalCrypt', value: true},
            150: {type: 'mult', name: 'currencyHordeSoulCorruptedGain', value: 1.2},
            200: {type: 'base', name: 'hordeMaxSacrifice', value: 1},
            300: {type: 'mult', name: 'hordeHealth', value: 1.5},
        },
    },
    danger: {
        unlock: 'hordeDangerTower',
        sigils: ['executing', 'focus', 'nuke', 'precision', 'power'],
        statBase: 245,
        statScaling: 0.4,
        crowns: 5,
        heirlooms: ['crystal'],
        reward: {
            50: {type: 'unlock', name: 'hordeUpgradeRoyalSecret', value: true},
            100: {type: 'mult', name: 'hordeAttack', value: 1.5},
            150: {type: 'base', name: 'currencyHordeMysticalShardCap', value: 10},
            200: {type: 'mult', name: 'hordeAttack', value: 1.5},
            300: {type: 'base', name: 'currencyHordeMysticalShardCap', value: 10},
        },
    },
    toxic: {
        unlock: 'hordeToxicTower',
        sigils: ['toxic', 'foulBreath', 'drain', 'spitting', 'sharp'],
        statBase: 290,
        statScaling: 0.45,
        crowns: 8,
        heirlooms: ['vitality'],
        reward: {
            50: {type: 'mult', name: 'hordeHealth', value: 1.5},
            100: {type: 'base', name: 'hordeMaxSacrifice', value: 1},
            150: {type: 'base', name: 'currencyHordeMysticalShardCap', value: 10},
            200: {type: 'mult', name: 'hordeAttack', value: 1.5},
        },
    },
    forest: {
        unlock: 'hordeForestTower',
        sigils: ['screaming', 'protection', 'shielding', 'recovery', 'drain'],
        statBase: 350,
        statScaling: 0.5,
        crowns: 13,
        heirlooms: ['nature'],
        reward: {
            50: {type: 'unlock', name: 'hordeUpgradeRoyalBlessing', value: true},
            100: {type: 'base', name: 'currencyHordeMysticalShardCap', value: 10},
        },
    },
}
